module.exports = __webpack_public_path__ + "img/add_btn_icon120.0f41418a.svg";